/* Plays only the video that matches the current breakpoint, and only while
   the section is in the viewport. The videos carry no autoplay attribute and
   preload="none", so the hidden one is never downloaded. */
class DualVideo extends HTMLElement {
  connectedCallback() {
    this.desktop = this.querySelector('.dual-video__desktop video');
    this.mobile = this.querySelector('.dual-video__mobile video');
    const bp = parseInt(this.dataset.breakpoint, 10) || 750;
    this.mq = window.matchMedia(`(min-width: ${bp}px)`);
    this.inView = false;

    this.mq.addEventListener('change', () => this.update());

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.inView = entry.isIntersecting;
        this.update();
      },
      { threshold: 0 }
    );
    this.observer.observe(this);

    this.update();
  }

  get active() {
    return this.mq.matches ? this.desktop : this.mobile;
  }

  get inactive() {
    return this.mq.matches ? this.mobile : this.desktop;
  }

  update() {
    this.inactive?.pause();
    const video = this.active;
    if (!video) return;
    if (this.inView) {
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    } else {
      video.pause();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('dual-video', DualVideo);
